import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_ModuleSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Summary"
    videos={[
       
      ]}
      takeaways={[
        {
            text: "For an average/below average student, learn all the theory concepts properly with some example codes. Mainly focus on loops and conditionals (with basic examples and flowcharts) and learn theory from type conversions."
          },
          {
            text: "Possibility of coding questions like swapping two numbers without a temporary variable and solving quadratic equations using discriminant."
          },
          {
            text: "Coding questions from this module won’t be tricky. Just read the question properly to understand what to do. If you don't know exactly what to do, at least write the basic code structure."
          },
          {
            text: "As code logic can differ from student to student, it's better to write an explanation of the code (what you are doing) if time permits."
          },
          {
            text: "Write sample input and output for every code, as this carries some marks."
          }
      ]}
      questions={[
        
      ]}
      exampleVideos={[]} // Add if any examples are needed.
    />
);
}

export default OOPS_M1_ModuleSummary;
